export default {
    debug: false,

    loginHref: '/login',
    cartHref: '/shop/cart',
    adcHomeHref: '/adc',
    customerPortalHomeHref: '/account/settings',

    userStorage: 'fp:currentUser',

    linklists: {
        mainMenu: 'main-menu',
        portal: 'portal'
    },

    products: {
        maxPerCart: 10
    },

    coupon: {
        userSettingGroups: 'UserSetting:'
    },

    firmware: {
        versionNeededForZWave: '1.6.1'
    },

    supportedCountries: ['US', 'CA'],

    beta: {
        moving: true
    },

    monitoringPlans: {
        ultimate: { name: 'Ultimate Monitoring', abbreviation: 'UM' },
        interactive: { name: 'Interactive Monitoring', abbreviation: 'IM' },
        interactiveTrial: { name: 'Interactive Monitoring (Trial)', abbreviation: 'IM (Trial)' },
        protection: { name: 'Protection Monitoring', abbreviation: 'PM' },
        cameraOnly: { name: 'Camera Only', abbreviation: 'CO' }
    },

    panels: [
        { name: 'SIMONXT', shopAllowProperty: 'allow_xt', abbreviation: 'XT' },
        /*
         * Note: this change is executed under the assumption that as of 3/2023
         * the IQPanel in production has sunsetted. We assume moving forward that
         * the references to IQPanel will be for the IQPanel4. This is further
         * enforced by ADC returning the IQPanel4 name as simply: IQPanel
         */
        { name: 'IQPANEL', shopAllowProperty: 'allow_iq4', abbreviation: 'IQ' },
        { name: 'HSVGW', shopAllowProperty: 'allow_climax', abbreviations: 'CX' }
    ],

    skus: {
        frontpointHub: 'FrontpointHub',
        frontpointHubVersions: ['FrontpointHub', 'FPHUB2', 'FPHUB3', 'FPHUB3.1'],
        frontpointHubManufacturerSkus: ['Frontpoint Hub', 'FPHUB2', 'FPHUB3', 'FPHUB3.1'],
        frontpointKeypadManufacturerSkus: ['Frontpoint Keypad - Rubber Key', 'FPKEY2'],
        frontpointRubberKeypadV2: 'FPKEY2',
        frontpointRubberKeypad: 'FrontpointKeypadRubberKey',
        frontpointHubManufacturer: 'Frontpoint Hub',
        frontpointRubberKeypadManufacturer: 'Frontpoint Keypad - Rubber Key',
        frontpointTouchscreen: 'FPTS-1',
        verizonLteRadio: 'XT-510-FP-VZ'
    },

    panelType: {
        frontpointHub: ['HSVGW', 'HSGW'],
        simonXT: ['SimonXT']
    },

    paymentErrors: {
        billingAddress:
            'Your payment was declined due to your billing address. Please verify and update your billing address to proceed.',
        cardNumber:
            'Your payment was declined due to an invalid card number. Please enter a valid card number to proceed.',
        expirationDate: {
            declined:
                'Your payment was declined due to the expiration date. Please update your expiration date in the My Account section to proceed.',
            selected: 'Please update the expiration date on your credit card to proceed.'
        },
        duplicateCard:
            'Your form of payment already exists in our system. Please select the existing form of payment or enter new card information.',
    },
    cart2gError:
        'Your panel does not currently support the equipment selected. Please call our support department at 1-877-602-5276 to resolve this issue.',

    sectionTypes: {
        order: 'Order'
    },

    actionTypes: {
        orderSubmission: 'OrderSubmission',
        error: 'Error'
    }
};